exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action-cell * {\n  float: right; }\n\n::ng-deep snack-bar-container.custom-class {\n  background: white; }\n\n::ng-deep .custom-class .mat-simple-snackbar {\n  color: red; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /tmp/build_f0fbff5b/src/app/main/content/organisations/organisations.component.scss
// module id = ../../../../../src/app/main/content/organisations/organisations.component.scss
// module chunks = main